<template>
  <div
    v-if="badgeTitle"
    class="campaign-status-badge"
    :style="{
      backgroundColor: badgeConfig.colorCode,
      color: badgeConfig.textColorCode,
    }"
  >
    {{ badgeTitle }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DEFAULT_BADGE_TITLES } from '../constants';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
  definitions: {
    type: Array,
    default: () => [],
  },
});

const badgeConfig = computed(() => {
  const definition = props.definitions.find(
    (item) => item.code === props.status,
  );

  return {
    colorCode: definition?.colorCode,
    textColorCode: definition?.textColorCode,
    title: definition?.title,
  };
});

const badgeTitle = computed(
  () => badgeConfig.value.title || DEFAULT_BADGE_TITLES[props.status] || '',
);
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.campaign-status-badge {
  width: fit-content;
  height: 24px;
  align-self: flex-start;
  padding: 4px 8px;
  border: 0.5px solid $colorN30;
  border-radius: 4px;
  background-color: $colorB05;
  color: $colorB60;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
}
</style>
